import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import StopLineupsGeneration from 'components/molecules/stop-lineups-generation';

class Preloader extends Component {
    render() {
        const {rawLineups} = this.props;

        let quantity = rawLineups.getQuantity();
        if (!quantity) {
            return null;
        }

        return (
            <div className="players-heading lh-40">
                <strong>{quantity}</strong> Lineups
                <div className="pull-right">
                    <StopLineupsGeneration />
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {rawLineups} = state.lineupsData;

    return {
        rawLineups,
    };
}

export default connect(mapStatesToProps)(Preloader);
